export default __webpack_public_path__ + "static/media/IMG_9777 copie.c115a9ea.jpg";